import Vue from 'vue'
import Router from 'vue-router'
import axios from '../axios'
import store from '../store'

Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            name: '/',
            redirect: { name: "Index" },
            component: () =>
                import ('@/views/Index'),
            meta: {
                checkLogin: false,
                title: '',
            },
            children: [{
                    path: '/login',
                    name: 'Login',
                    component: () =>
                        import ('@/views/Index/Login'),
                    meta: {
                        checkLogin: false,
                        title: '登入',
                    }
                },
                {
                    path: '/register',
                    name: 'Register',
                    component: () =>
                        import ('@/views/Index/Register'),
                    meta: {
                        checkLogin: false,
                        title: '注册',
                    }
                },
                {
                    path: '/index',
                    name: 'Index',
                    component: () =>
                        import ('@/views/Index/Home'),
                    meta: {
                        checkLogin: false,
                        title: '首页',
                    }
                },
                {
                    path: '/about',
                    name: 'About',
                    component: () =>
                        import ('@/views/Index/About'),
                    meta: {
                        checkLogin: true,
                        title: '关于我们',
                    },
                },
                {
                    path: '/aboutQa',
                    name: 'AboutQa',
                    component: () =>
                        import ('@/views/Index/AboutQa'),
                    meta: {
                        checkLogin: true,
                        title: '关于我们',
                    },
                },
                {
                    path: '/scratch',
                    name: 'Scratch',
                    component: () =>
                        import ('@/views/Index/Scratch'),
                    meta: {
                        checkLogin: true,
                        title: '刮刮乐',
                    },
                },
                /*{
                  path: '/trade',
                  name: 'Trade',
                  component: () => import('@/views/Index/Trade'),
                  meta: {
                    checkLogin: true,
                    title: '市场',
                  },
                },*/
                {
                    path: '/member/index',
                    name: 'memberIndex',
                    component: () =>
                        import ('@/views/Index/Member/Index'),
                    meta: {
                        checkLogin: true,
                        title: '用户资讯',
                    },
                    children: [{
                            path: '/member/center',
                            name: 'memberCenter',
                            component: () =>
                                import ('@/views/Index/Member/Center'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-详细资料',
                            },
                        },
                        {
                            path: '/member/setting',
                            name: 'memberSetting',
                            component: () =>
                                import ('@/views/Index/Member/Setting'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-修改密码',
                            },
                        },
                        {
                            path: '/member/deposit',
                            name: 'memberDeposit',
                            component: () =>
                                import ('@/views/Index/Member/Deposit'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-充值',
                            },
                        },
                        {
                            path: '/member/withdraw',
                            name: 'memberWithdraw',
                            component: () =>
                                import ('@/views/Index/Member/Withdraw'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-提现',
                            },
                        },
                        {
                            path: '/member/bank',
                            name: 'memberBank',
                            component: () =>
                                import ('@/views/Index/Member/Bank'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-钱包',
                            },
                        },
                        {
                            path: '/member/activity',
                            name: 'memberActivity',
                            component: () =>
                                import ('@/views/Index/Member/Activity'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-活动',
                            },
                        },
                        {
                            path: '/member/notice',
                            name: 'memberNotice',
                            component: () =>
                                import ('@/views/Index/Member/Notice'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-公告',
                            },
                        },
                        {
                            path: '/member/record',
                            name: 'memberRecord',
                            component: () =>
                                import ('@/views/Index/Member/Record'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-记录',
                            },
                        },
                        {
                            path: '/member/service',
                            name: 'memberService',
                            component: () =>
                                import ('@/views/Index/Member/Service'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-服务条款',
                            },
                        },
                        {
                            path: '/member/message',
                            name: 'memberMessage',
                            component: () =>
                                import ('@/views/Index/Member/Message'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-讯息',
                            },
                        },
                        {
                            path: '/member/send',
                            name: 'memberSend',
                            component: () =>
                                import ('@/views/Index/Member/Send'),
                            meta: {
                                checkLogin: true,
                                title: '用户资讯-发送',
                            },
                        },
                    ]
                },
            ]
        },
        {
            path: '*',
            redirect: { name: "Index" },
        }, //全不匹配的情况下，返回到主页，路由按顺序从上到下，依次匹配。最后一个*能匹配全部，

    ]
})

//路由守卫
router.beforeEach((to, from, next) => {
    if (to.meta.checkLogin == true) {
        //判断token是否存在
        if (!localStorage.getItem('X-Token')) {
            router.push({
                name: 'Login'
            })
            return false;
        }
    }
    next();
})

router.afterEach((to, from) => {
    //如果登录的话 获取用户信息
    /*if (to.meta.checkLogin) {
      axios.get("/info").then(res => {
        const data = res.data;
        if (data.code == 200) {
          store.state.user = data.data;
        }
      })
    }*/
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js